import { AGENT_MODEL } from '@nrwl/common-lib';
import {
  DEFAULT_FLOWS,
  ETHER_TYPE_LABEL,
  IPAddressValue,
  MOS_CONFIG,
  vlanConfigLabel,
  vlanConfigValue,
  definedAddressValue,
  TRANSMIT_INTERFACE_VALUE,
  TwampConfigFieldMapping as ConfigFieldMapping,
  IPAddressLabel
} from '../components/models/model';

export const TWAMP_AGENT_MODEL_CONFIG = {
  id: 'twamp_test',
  agentConfig: {
    default: {
      setup: {
        alias: {
          enabled: true,
          value: 'Twamp',
          outputField: ConfigFieldMapping.ALIAS,
          tabId: 'twamp_setup',
          restoreOnAgentChange: true
        },
        customer: {
          enabled: true,
          value: '',
          outputField: ConfigFieldMapping.CUSTOMER,
          tabId: 'twamp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technician: {
          enabled: true,
          value: '',
          outputField: ConfigFieldMapping.TECHINICIAN,
          tabId: 'twamp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        contact: {
          enabled: true,
          value: '',
          outputField: 'contact',
          tabId: 'twamp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        email: {
          enabled: true,
          value: '',
          outputField: 'email',
          tabId: 'twamp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        phone: {
          enabled: true,
          value: '',
          outputField: 'phone',
          tabId: 'twamp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technicianId: {
          enabled: true,
          value: '',
          outputField: 'technicianId',
          tabId: 'twamp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        runType: {
          enabled: true,
          value: 'on-going',
          outputField: ConfigFieldMapping.RUN_TYPE,
          tabId: 'twamp_setup',
          restoreOnAgentChange: true
        },
        agentType: {
          enabled: true,
          value: 'default',
          outputField: ConfigFieldMapping.AGENT_TYPE,
          tabId: 'twamp_setup',
          restoreOnAgentChange: true
        },
        selectedOriginator: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SELECTED_ORIGINATOR,
          tabId: 'twamp_setup',
          restoreOnAgentChange: true
        },
        selectedDestination: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SELECTED_DESTINATION,
          tabId: 'twamp_setup',
          restoreOnAgentChange: true
        },
        selectedDestinationAgents: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SELECTED_DESTINATION_AGENTS,
          tabId: 'twamp_setup',
          restoreOnAgentChange: true,
          outputOptional: true
        },
        transmitInterface: {
          enabled: false,
          value: TRANSMIT_INTERFACE_VALUE.EQUIPMENT,
          outputField: ConfigFieldMapping.TRANSMIT_INTERFACE,
          tabId: 'twamp_setup',
          outputOptional: true
        },
        ipAddressType: {
          enabled: true,
          value: IPAddressValue.IP_V4,
          outputField: ConfigFieldMapping.IP_ADDRESS_TYPE,
          options: {
            type: 'dropdown',
            value: [{ name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 }]
          },
          tabId: 'twamp_setup'
        },
        macAddress: {
          enabled: false,
          value: '00:11:22:33:44:55',
          outputField: ConfigFieldMapping.MAC_ADDRESS,
          tabId: 'twamp_setup',
          outputOptional: true
        },
        networkMacAddress: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.NETWORK_MAC,
          lookup: ["capabilities.phy['network-mac']"],
          tabId: 'twamp_setup',
          outputOptional: true
        },
        equipmentMacAddress: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.EQUIPMENT_MAC,
          lookup: ["capabilities.phy['equipment-mac']"],
          tabId: 'twamp_setup',
          outputOptional: true
        },
        definedAddress: {
          enabled: false,
          value: definedAddressValue.TEST_IP,
          outputField: ConfigFieldMapping.DEFINED_ADDRESS,
          tabId: 'twamp_setup',
          outputOptional: true
        },
        assignedIP: {
          enabled: false,
          value: null,
          outputField: ConfigFieldMapping.ASSIGNED_IP_ADDRESS,
          tabId: 'twamp_setup',
          outputOptional: true
        },
        address: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.ADDRESS,
          tabId: 'twamp_setup'
        },
        subnet: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SUBNET,
          tabId: 'twamp_setup'
        },
        gateway: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.GATEWAY,
          tabId: 'twamp_setup'
        },
        baseUdp: {
          enabled: true,
          value: 50000,
          outputField: ConfigFieldMapping.BASE_UDP,
          tabId: 'twamp_setup'
        },
        vlanConfig: {
          enabled: true,
          value: vlanConfigValue.UNTAGGED,
          outputField: ConfigFieldMapping.VLAN_CONFIG,
          options: {
            type: 'dropdown',
            value: [
              { name: vlanConfigLabel.UNTAGGED, value: vlanConfigValue.UNTAGGED },
              { name: vlanConfigLabel.SINGLE_VLAN, value: vlanConfigValue.SINGLE_VLAN }
            ]
          },
          tabId: 'twamp_setup'
        },
        selectedReflectorIds: {
          enabled: true,
          value: [],
          outputField: ConfigFieldMapping.SELECTED_REFLECTOR_IDS,
          tabId: 'twamp_setup',
          outputOptional: true
        },

        vlanId: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.SVLAN_ID,
          tabId: 'twamp_setup',
          outputOptional: true
        },
        vlanPriority: {
          enabled: true,
          value: 0,
          outputField: ConfigFieldMapping.SVLAN_PRIORITY,
          tabId: 'twamp_setup',
          outputOptional: true
        },
        cvlanId: {
          enabled: true,
          value: null,
          outputField: ConfigFieldMapping.CVLAN_ID,
          tabId: 'twamp_setup',
          outputOptional: true
        },
        cvlanPriority: {
          enabled: true,
          value: 0,
          outputField: ConfigFieldMapping.CVLAN_PRIORITY,
          tabId: 'twamp_setup',
          outputOptional: true
        },
        cvlanEthertype: {
          enabled: true,
          value: ETHER_TYPE_LABEL.ETHER_8100,
          outputField: ConfigFieldMapping.CVLAN_ETHER_TYPE,
          tabId: 'twamp_setup',
          outputOptional: true
        },
        interval: {
          enabled: true,
          value: 60,
          outputField: ConfigFieldMapping.PM_INTERVAL,
          tabId: 'twamp_advanced'
        },
        codec: {
          enabled: false,
          value: MOS_CONFIG.NONE,
          outputField: ConfigFieldMapping.CODEC,
          tabId: 'twamp_advanced'
        },
        percentiles: {
          enabled: false,
          value: false,
          outputField: ConfigFieldMapping.ENABLE_PERCENTILES,
          tabId: 'twamp_advanced'
        },
        keepAlive: {
          enabled: true,
          value: false,
          outputField: ConfigFieldMapping.KEEP_ALIVE,
          tabId: 'twamp_advanced'
        },
        reboot: {
          enabled: false,
          value: false,
          outputField: ConfigFieldMapping.REBOOT,
          tabId: 'twamp_advanced'
        },
        reflectorUDP: {
          enabled: true,
          value: 50000,
          outputField: ConfigFieldMapping.REFLECTOR_UDP,
          tabId: 'twamp_advanced'
        },
        commonFlows: {
          enabled: true,
          value: DEFAULT_FLOWS,
          outputField: ConfigFieldMapping.COMMON_FLOWS,
          tabId: 'twamp_advanced',
          restoreOnAgentChange: true
        },
        specificFlows: {
          enabled: true,
          value: {},
          outputField: ConfigFieldMapping.SPECIFIC_FLOWS,
          tabId: 'twamp_advanced',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        selectedTab: {
          enabled: true,
          value: 0,
          outputField: ConfigFieldMapping.SELECTED_TAB,
          tabId: 'twamp_advanced',
          restoreOnAgentChange: true
        }
      },

      running: {
        add: 'anything that is different between agents in running view'
      },

      final: {
        add: 'anything that is different between agents in final report'
      }
    },
    [AGENT_MODEL.VPMA]: {
      setup: {
        ipAddressType: {
          enabled: true,
          value: IPAddressValue.IP_V4,
          outputField: ConfigFieldMapping.IP_ADDRESS_TYPE,
          options: {
            type: 'dropdown',
            value: [
              { name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 },
              { name: IPAddressLabel.IP_V6, value: IPAddressValue.IP_V6 }
            ]
          },
          tabId: 'twamp_setup'
        },
        vlanConfig: {
          enabled: true,
          value: vlanConfigValue.UNTAGGED,
          outputField: ConfigFieldMapping.VLAN_CONFIG,
          options: {
            type: 'dropdown',
            value: [
              { name: vlanConfigLabel.UNTAGGED, value: vlanConfigValue.UNTAGGED },
              { name: vlanConfigLabel.SINGLE_VLAN, value: vlanConfigValue.SINGLE_VLAN },
              { name: vlanConfigLabel.Q_IN_Q, value: vlanConfigValue.Q_IN_Q }
            ]
          },
          tabId: 'twamp_setup'
        },
        percentiles: {
          enabled: true
        },
        codec: {
          enabled: true
        },
        reboot: {
          enabled: true
        }
      }
    },
    [AGENT_MODEL.VSPA_PM]: {
      setup: {
        vlanConfig: {
          enabled: true,
          value: vlanConfigValue.UNTAGGED,
          outputField: ConfigFieldMapping.VLAN_CONFIG,
          options: {
            type: 'dropdown',
            value: [
              { name: vlanConfigLabel.UNTAGGED, value: vlanConfigValue.UNTAGGED },
              { name: vlanConfigLabel.SINGLE_VLAN, value: vlanConfigValue.SINGLE_VLAN },
              { name: vlanConfigLabel.Q_IN_Q, value: vlanConfigValue.Q_IN_Q }
            ]
          },
          tabId: 'twamp_setup'
        },
        percentiles: {
          enabled: true
        },
        codec: {
          enabled: true
        },
        reboot: {
          enabled: true
        }
      }
    },
    [AGENT_MODEL.VPMA_L]: {
      setup: {
        ipAddressType: {
          enabled: true,
          value: IPAddressValue.IP_V4,
          outputField: ConfigFieldMapping.IP_ADDRESS_TYPE,
          options: {
            type: 'dropdown',
            value: [
              { name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 },
              { name: IPAddressLabel.IP_V6, value: IPAddressValue.IP_V6 }
            ]
          },
          tabId: 'twamp_setup'
        },
        vlanConfig: {
          enabled: true,
          value: vlanConfigValue.UNTAGGED,
          outputField: ConfigFieldMapping.VLAN_CONFIG,
          options: {
            type: 'dropdown',
            value: [
              { name: vlanConfigLabel.UNTAGGED, value: vlanConfigValue.UNTAGGED },
              { name: vlanConfigLabel.SINGLE_VLAN, value: vlanConfigValue.SINGLE_VLAN },
              { name: vlanConfigLabel.Q_IN_Q, value: vlanConfigValue.Q_IN_Q }
            ]
          },
          tabId: 'twamp_setup'
        },
        percentiles: {
          enabled: true
        },
        codec: {
          enabled: true
        },
        reboot: {
          enabled: true
        }
      }
    },
    [AGENT_MODEL.VSPA_PM_L]: {
      setup: {
        vlanConfig: {
          enabled: true,
          value: vlanConfigValue.UNTAGGED,
          outputField: ConfigFieldMapping.VLAN_CONFIG,
          options: {
            type: 'dropdown',
            value: [
              { name: vlanConfigLabel.UNTAGGED, value: vlanConfigValue.UNTAGGED },
              { name: vlanConfigLabel.SINGLE_VLAN, value: vlanConfigValue.SINGLE_VLAN },
              { name: vlanConfigLabel.Q_IN_Q, value: vlanConfigValue.Q_IN_Q }
            ]
          },
          tabId: 'twamp_setup'
        },
        percentiles: {
          enabled: true
        },
        codec: {
          enabled: true
        },
        reboot: {
          enabled: true
        }
      }
    },
    [AGENT_MODEL.JMEP_1G]: {
      setup: {
        transmitInterface: { enabled: true },
        macAddress: { enabled: true },
        networkMacAddress: {
          enabled: true
        },
        ipAddressType: {
          enabled: true,
          value: IPAddressValue.IP_V4,
          outputField: ConfigFieldMapping.IP_ADDRESS_TYPE,
          options: {
            type: 'dropdown',
            value: [{ name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 }]
          },
          tabId: 'twamp_setup'
        },
        equipmentMacAddress: { enabled: true },
        definedAddress: { enabled: true },
        assignedIP: {
          enabled: true,
          lookup: ["capabilities.phy['assigned-ip']"]
        },
        address: {
          lookup: ["capabilities.phy['test-ip']"]
        },
        subnet: {
          lookup: ['capabilities.phy.subnet']
        },
        gateway: {
          lookup: ['capabilities.phy.gateway']
        },
        vlanId: {
          enabled: true,
          lookup: ["capabilities.phy['test-vlan-id']"]
        },
        vlanConfig: {
          enabled: true
        },
        interval: {
          enabled: true
        },
        percentiles: {
          enabled: false
        },
        codec: {
          enabled: false
        },
        reboot: {
          enabled: false
        }
      }
    },
    [AGENT_MODEL.QT600]: {
      setup: {
        ipAddressType: {
          enabled: true,
          value: IPAddressValue.IP_V4,
          outputField: ConfigFieldMapping.IP_ADDRESS_TYPE,
          options: {
            type: 'dropdown',
            value: [
              { name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 },
              { name: IPAddressLabel.IP_V6, value: IPAddressValue.IP_V6 }
            ]
          },
          tabId: 'twamp_setup'
        }
      }
    }
  }
};
